export class BankAccountInfoFields {
  routing_number: string;
  account_number: string;

  constructor() {
    this.routing_number = '';
    this.account_number = '';
  }
}

export class BankAccountPaymentMethod {
  email: string;
  bank_account: {
    account_owner_name: string;
    routing_number: string;
    account_number: string;
    account_type: string;
    account_owner_type: string;
    country: string;
    currency: string;
    metadata: any;
  }

  constructor(paymentMethodMetadata: any, bankAccountInfo: BankAccountInfoFields) {
    this.email = paymentMethodMetadata.email;
    this.bank_account = {
      account_owner_name: paymentMethodMetadata.name || paymentMethodMetadata.account_owner_name,
      routing_number: bankAccountInfo.routing_number,
      account_number: bankAccountInfo.account_number,
      account_type: paymentMethodMetadata.account_type || 'checking',
      account_owner_type: paymentMethodMetadata.account_owner_type || 'individual',
      country: paymentMethodMetadata.country || 'US',
      currency: paymentMethodMetadata.currency || 'usd',
      metadata: paymentMethodMetadata.metadata
    };
  }
}
